/**
 * Whether a failed read means this person cannot see the care map, rather than that the read failed.
 * Both are routine for agency staff: a client shared neither with the organization nor with them was never theirs to open, and a share
 * can be withdrawn while a list that still offered it is on screen.
 */
export const isNoCareMapAccessError = (err?: { status?: number; errorCode?: string }): boolean => {
    // The api's own refusal, not any 403: a gateway or proxy can answer 403 too
    return err?.errorCode === 'not-found' || (err?.status === 403 && err?.errorCode === 'not-authorized');
};

export const NO_CARE_MAP_ACCESS_ALERT = {
    header: 'Care Recipient Not Found',
    message: `We're sorry, you don't have access to the care recipient you are trying to view.`
};
